import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'HODLX',
  description:
    'A Friendly Decentralized Exchange',
  image: 'https://hodlx.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('HODLX')} | ${t('Home')}`,
      }
    case '/swap':
      return {
        title: `${t('Decentralized Crypto Exchange')} | ${t('Exchange for Cryptocurrency')} | ${t('HODLX')}`,
      }
    case '/add':
      return {
        title: `${t('Crypto Liquidity Pool')} | ${t('Add Liquidity')}`,
      }
    case '/remove':
      return {
        title: `${t('Crypto Liquidity Pool')} | ${t('Remove Liquidity')}`,
      }
    case '/liquidity':  
      return {
        title: `${t('Crypto Liquidity Pool')} | ${t('Liquidity Pools')}`,
      }
    case '/find':
      return {
        title: `${t('Crypto Liquidity Pool')} | ${t('Import Pool')}`,
      }
    case '/competition':
      return {
        title: `${t('HODLX')} | ${t('Trading Battle')}`,
      }
    case '/prediction':
      return {
        title: `${t('HODLX')} | ${t('Prediction')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('HODLX')} | ${t('Leaderboard')}`,
      }
    case '/farms':
      return {
        title: `${t('Yield Farming Platform')} | ${t('Crypto Farming')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Yield Farming Platform')} | ${t('Farm Auctions')}`,
      }
    case '/pools':
      return {
        title: `${t('Crypto Staking Rewards')} | ${t('Cryptocurrency Staking')}`,
      }
    case '/referral':
      return {
        title: `${t('Cryptocurrency Affiliate Program')} | ${t('Referrals')}`,
      }
    case '/lottery':
      return {
        title: `${t('HODLX')} | ${t('Lottery')}`,
      }
    case '/ifo':
      return {
        title: `${t('HODLX')} | ${t('Initial Farm Offering')}`,
      }
    case '/teams':
      return {
        title: `${t('HODLX')} | ${t('Leaderboard')}`,
      }
    case '/voting':
      return {
        title: `${t('HODLX')} | ${t('Voting')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('HODLX')} | ${t('Proposals')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('HODLX')} | ${t('Make a Proposal')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('HODLX Info & Analytics')}`,
        description: 'View statistics for HODLX exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('HODLX Info & Analytics')}`,
        description: 'View statistics for HODLX exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('HODLX Info & Analytics')}`,
        description: 'View statistics for HODLX exchanges.',
      }
    case '/nfts':
      return {
        title: `${t('HODLX')} | ${t('Overview')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('HODLX')} | ${t('Collections')}`,
      }
    case '/nfts/activity':
      return {
        title: `${t('HODLX')} | ${t('Activity')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('HODLX')} | ${t('Profile')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('HODLX')} | ${t('Pancake Squad')}`,
      }
    default:
      return null
  }
}
